import { BrowserRouter } from "react-router-dom";
import { Simulation } from "./features";

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Simulation />
      </div>
    </BrowserRouter>
  );
}

export default App;
